import { Button } from '@kontentino/ui';
import BaseSubscriptionModal from 'app/components/subscriptionModals/BaseSubscriptionModal';
import insightsIcon from 'app/images/insightsModalGreet.svg';
import IntercomUtils from 'app/utils/intercom';
import { FC } from 'react';
import { useTranslation, Trans } from 'react-i18next';

type Props = {
  open: boolean;
  onStartTrialNow(): void;
};

const InsightsTrialStart: FC<Props> = ({ open, onStartTrialNow }) => {
  const { t } = useTranslation();

  return (
    <BaseSubscriptionModal
      open={open}
      title={
        <div className="tw-text-xl tw-font-medium">
          <Trans
            i18nKey="insights.trialStart.title"
            components={{ 1: <strong />, 3: <strong /> }}
          />
        </div>
      }
      description={
        <div className="tw-text-center tw-text-md">
          <Trans
            i18nKey="insights.trialStart.description"
            components={{ 1: <span className="tw-font-bold" /> }}
          />
        </div>
      }
      image={<img src={insightsIcon} alt="Analytics icon" />}
      buttons={
        <>
          <Button onClick={onStartTrialNow} className="tw-w-full">
            {t('insights.trialStart.startTrialButton')}
          </Button>

          <Button
            variant={'secondary'}
            onClick={() =>
              IntercomUtils.newConversation('Hello! Just having a question')
            }
            className="tw-w-full"
          >
            {t('insights.trialStart.contactUsButton')}
          </Button>
        </>
      }
    />
  );
};

export default InsightsTrialStart;
